// eslint-disable-next-line
import axios from "axios";

const httpService = {
  methods: {
    $post: function (url, params) {
      return axios.post(url, params);
    },

    $get: function (url, params) {
      return axios.get(url, {
        params: params
      });
    },

    $put: function (url, params) {
      return axios.put(url, params);
    },
    $postMultipart: function(url, form){
      return axios.post(url,form,{
        headers: {
          'Content-Type' : 'multipart/form-data'
        }
      })
    }
  }
};

export default httpService;



// WEBPACK FOOTER //
// ./src/utils/httpService.js